
<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
      <template #action>
        <div class="overflow-auto">
          <div class="ml-auto w-fit mt-1 mr-1">
            <!-- 閉じる -->
            <SecondaryButton
              text="閉じる"
              @click="closed()"
            ></SecondaryButton>
          </div>
          <div>
            <div class="text-lg text-blue-800 font-bold">{{target.siteName}}</div>
            <div class="text-sm text-blue-800">{{target.clientName1}}</div>
          </div>

          <div class="my-3">
            {{target.selectedDate}} の他に作業する日を選択してください。
          </div>

          <div class="w-fit mx-auto">
            <v-date-picker
              mode="multiple"
              :value="targetDate"
              :min-date="minLimitDate"
              @input="selected" >
            </v-date-picker>
          </div>

          <div class="h-52 overflow-auto border border-gray-300 mt-3 rounded w-72 mx-auto">
            <div v-for="(row, i) in selectedDate" :key="i" class="rounded-md bg-skybl text-blue-50 font-bold px-3 py-1 mx-auto my-1 w-fit">
              <div class="flex mb-1">  
                <div class="whitespace-nowrap">{{ row.day }}</div>
                <div class="my-auto ml-auto">
                  <TrashIcon class="text-gray-300 cursor-pointer hover:text-gray-50 active:text-gray-600 w-5 h-5" @click="deleteDate(i)"/>
                </div>
              </div>
              
              <div class="flex text-gray-700">
                <div class="bg-white rounded p-0.5">
                  <input type="number"
                    v-model="row.sHour"
                    class="w-10 border-0 rounded px-0.5 py-1 text-center"
                    @wheel.prevent
                  >
                  <span class="text-gray-700 font-bold">：</span>
                  <input type="number"
                    :ref="i + 'sm'"
                    v-model="row.sMinu"
                    class="w-10 border-0 rounded px-0.5 py-1 text-center"
                    @wheel.prevent
                  >
                </div>

                <div class="px-1 text-white font-bold self-center">～</div>

                <div class="bg-white rounded p-0.5">
                  <input type="number"
                    v-model="row.eHour"
                    class="w-10 border-0 rounded px-0.5 py-1 text-center"
                    @wheel.prevent
                  >
                  <span class="text-gray-700 font-bold">：</span>
                  <input type="number"
                    v-model="row.eMinu"
                    class="w-10 border-0 rounded px-0.5 py-1 text-center"
                    @wheel.prevent
                  >
                </div>
              </div>
            </div>
          </div>
          

          <div class="flex m-3">
            <PrimaryButton text="全て削除" size="normal" class="w-full bg-light-blue-200 text-light-blue-800 mr-2" @click="allDelete(true)" />
            <PrimaryButton text="決定" size="normal" class="w-full ml-2" @click="save()" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import * as moment from 'moment'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'

export default {
  components: {
    Modal,
    PrimaryButton,
    SecondaryButton,
    TrashIcon,
  },

  props: {
    target: {
      type: Object
    },
    open: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      // 作業日
      targetDate: '',
      // 連日データ
      selectedDate: [],
      // カレンダー最少日
      minLimitDate: ''
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (!this.open) {
        return
      }
      this.minLimitDate = moment(this.target.selectedDate).add(1, 'd').format('YYYY-MM-DD')
      this.getTarget()
    },
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      if (this.target.subDate) {
        this.selectedDate = utils.clone(this.target.subDate)
      }
    },

    /**
     * 初期化
     */
    closed() {
      // 作業日
      this.targetDate = null,
      // 選択した日
      this.selectedDate = [],
      this.subTime = []
      // カレンダー最少日
      this.minLimitDate = ''
      this.$emit('modalClose', false)
    },

    /**
     * カレンダー選択
     * @param val 選択日付
     */
    selected(val) {
      // moment.locale("ja", { weekdaysShort: ["日","月","火","水","木","金","土"], })
      if (!val) {
        return
      }
      // const date = moment(val).format('YYYY-MM-DD (ddd)')
      const day = moment(val).format('YYYY-MM-DD')
      for (let i = 0; i < this.selectedDate.length; i++) {
        const row = this.selectedDate[i]
        if (row.day == day) {
          return
        }
      }
      this.selectedDate.push({ day, sHour: null, sMinu: null, eHour: null, eMinu: null })
    },

    /**
     * 日付削除
     * @param i インデックス
     */
    deleteDate(i) {
      this.selectedDate.splice(i, 1)
    },

    /**
     * すべて削除
     */
    allDelete() {
      this.selectedDate = []
    },

    /**
     * 決定処理
     */
    async save() {
      for (let i = 0; i < this.selectedDate.length; i++) {
        const s = this.selectedDate[i]

        // 予定時間
        if (!s.sHour || !s.sMinu || !s.eHour || !s.eMinu) {
          await dialogs.showErrorDialog(s.day + 'の予定時刻 未完成', `予定時刻を完成させてください。`)
          return
        }
        if (Number(s.sHour) <= 0 || Number(s.sHour) >= 24 || isNaN(s.sHour)) {
          s.sHour = null
          await dialogs.showErrorDialog(s.day + 'の予定開始時刻', `予定時刻を完成させてください。`)
          return
        }
        if (Number(s.sMinu) < 0 || Number(s.sMinu) >= 60 || isNaN(s.sMinu)) {
          s.sMinu = null
          await dialogs.showErrorDialog(s.day + 'の予定開始時刻', `予定時刻を完成させてください。`)
          return
        }
        if (Number(s.eHour) <= 0 || Number(s.eHour) >= 24 || isNaN(s.eHour)) {
          s.eHour = null
          await dialogs.showErrorDialog(s.day + 'の予定終了時刻', `予定時刻を完成させてください。`)
          return
        }
        if (Number(s.eMinu) < 0 || Number(s.eMinu) >= 60 || isNaN(s.eMinu)) {
          s.eMinu = null
          await dialogs.showErrorDialog(s.day + 'の予定終了時刻', `予定時刻を完成させてください。`)
          return
        }
        s.sh = String(s.sHour).padStart(2, '0')
        s.sm = String(s.sMinu).padStart(2, '0')
        s.eh = String(s.eHour).padStart(2, '0')
        s.em = String(s.eMinu).padStart(2, '0')

        s.scheduledStartTime = s.sh + ':' + s.sm
        s.scheduledEndTime = s.eh + ':' + s.em

        if (s.scheduledStartTime >= s.scheduledEndTime) {
          await dialogs.showErrorDialog('予定時刻 不正', `予定時刻が不正です。開始時刻と終了時刻をご確認ください。`)
          return
        }
      }
      const save = utils.clone(this.selectedDate)
      this.$emit('selectedMulti', {save, idx: this.target.idx})
      this.closed()
    },

    /**
     * 自動で次の入力フォームへ
     */
    // autoNext(e, nextRef) {
    //   const val = e.target.value
    //   // 2桁以上入力したら次の入力フォームへ
    //   if (val && val.length >= 2) {
    //     this.$refs[nextRef][0].focus()
    //   }
    // }
  }
}
</script>